import VeniceHeroSection from "./components/HeroSection";
import VeniceStickyNav from "./components/StickyNav";
import VeniceProcessingTimeSection from "./components/ProcessingTimeSection";
import VeniceServicesSection from "./components/ServicesSection";
import VeniceLocalAreaSection from "./components/LocalAreaSection";
import VeniceTravelTimingSection from "./components/TravelTimingSection";
import VeniceDestinationsSection from "./components/DestinationsSection";
import VeniceTestimonialsSection from "./components/TestimonialsSection";
import VeniceAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import VeniceComparisonSection from "./components/ComparisonSection";
import VeniceMistakesSection from "./components/MistakesSection";
import VeniceHowItWorksSection from "./components/HowItWorksSection";
import VeniceFAQSection, { faqs } from "./components/FAQSection";
import VeniceHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import VeniceFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function VenicePage() {
  return (
    <div className="min-h-screen bg-white">
      <CitySEOHead
        city="Venice"
        state="Florida"
        stateAbbr="FL"
        route="/cities/venice"
        title="Emergency Passport Venice, FL — Expedited Same-Day Service | Fast Passport Center"
        description="Emergency and expedited passport services in Venice, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Sarasota County travelers, theatre festival visitors, and snowbirds."
        geoPlacename="Venice, Florida"
        geoPosition="27.0998;-82.4543"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
      />
      <VeniceHeroSection />
      <VeniceStickyNav />
      <VeniceProcessingTimeSection />
      <VeniceServicesSection />
      <VeniceLocalAreaSection />
      <VeniceTravelTimingSection />
      <VeniceDestinationsSection />
      <VeniceTestimonialsSection />
      <VeniceAcceptanceFacilitiesSection />
      <VeniceComparisonSection />
      <VeniceMistakesSection />
      <VeniceHowItWorksSection />
      <VeniceFAQSection />
      <VeniceHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/venice" state="FL" />
      <VeniceFinalCTA />
    </div>
  );
}